import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const formatAnswer = (value) => {
  if (value === null || value === undefined || value === "") return "—";
  if (Array.isArray(value)) return `${value.length} elementi`;
  if (typeof value === "object" && value.choice) {
    const labels = { SI: "Sì", NO: "No", NON_APPLICABILE: "Non applicabile", NON_DISPONIBILE: "Non disponibile" };
    return `${labels[value.choice] || value.choice}${value.description ? `: ${value.description}` : ""}`;
  }
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
};

// Riquadro "Correggi le incongruenze": elenco e conteggio arrivano SOLO dal backend.
export function CorrectionsPanel({ corrections, readOnly = false, compact = false, testid = "corrections-panel" }) {
  if (!corrections || corrections.length === 0) return null;
  const n = corrections.length;
  return (
    <div className="rounded-lg border border-red-300 bg-red-50 p-4 space-y-3" data-testid={testid}>
      <p className="text-sm font-semibold text-red-900 flex items-center gap-2" data-testid={`${testid}-title`}>
        <AlertTriangle className="w-4 h-4 shrink-0" aria-hidden="true" />
        Occorre correggere <span data-testid={`${testid}-count`}>{n}</span> {n === 1 ? "risposta" : "risposte"} prima di inviare il questionario al consulente.
      </p>
      <ul className="space-y-2">
        {corrections.map((c) => (
          <li key={c.key} className="rounded-md border border-red-100 bg-white px-3 py-2 text-sm"
            data-testid={`correction-item-${c.key}`}>
            <div className="flex flex-wrap items-start justify-between gap-2">
              <div className="min-w-0 flex-1 space-y-0.5">
                <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500">
                  {c.section_title}{c.question_number != null ? ` · Domanda ${c.question_number}` : ""}
                </p>
                <p className="font-medium text-slate-900" data-testid={`correction-text-${c.key}`}>{c.question_text}</p>
                {!compact && (
                  <p className="text-xs text-slate-700">
                    Risposta attuale: <strong data-testid={`correction-answer-${c.key}`}>{formatAnswer(c.answer_value)}</strong>
                  </p>
                )}
                <ul className="text-xs text-red-800 list-disc list-inside" data-testid={`correction-reasons-${c.key}`}>
                  {c.reasons.map((r, i) => <li key={i}>{r}</li>)}
                </ul>
              </div>
              {!readOnly && (
                <Link to={c.link} data-testid={`correction-fix-${c.key}`} className="shrink-0">
                  <Button variant="outline" size="sm" className="h-7 text-xs border-red-300 text-red-800">
                    Correggi <ArrowRight className="ml-1 h-3 w-3" aria-hidden="true" />
                  </Button>
                </Link>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
